export const hotjarEvent = (eventName) => {
    if (typeof window !== 'undefined' && typeof window.hj === 'function') {
        try {
            window.hj('event', eventName);
        }
        catch (e) {
            console.warn('[RLA] Hotjar call failed:', e);
        }
    }
};
//# sourceMappingURL=index.js.map